<template>
    <div>

        <el-row style="margin-bottom:10px;">
            <el-col :span="18" class='flex'>
                <el-select v-model='getSysDruidLogList_data.sdlType' clearable @change="getData" size="small"
                    placeholder="选择类型">
                    <el-option label="记录" :value="1">
                    </el-option>
                    <el-option label="新建" :value="2">
                    </el-option>
                </el-select>
                <el-select v-model='getSysDruidLogList_data.sdlInstance' clearable @change="getData"
                    size="small" placeholder="选择服务模块">
                    <el-option v-for="item in theLogInstanceAll" :key="item.name" :label="item.label"
                        :value="item.name">
                    </el-option>
                </el-select>
                <el-input v-model="getSysDruidLogList_data.sdlIp" placeholder="请输入请求微服务ip" clearable size='small'
                    style="max-width:200px;" />
                <el-date-picker v-model="valueDate" size='small' type="datetimerange" :picker-options="pickerOptions"
                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="timeChange"
                    value-format="yyyy-MM-dd HH:mm:ss" align="right">
                </el-date-picker>
                <el-button v-click.getSysDruidLogList type="primary" icon='el-icon-search' size='small'
                    style='margin-left:10px;'>搜索
                </el-button>
            </el-col>
        </el-row>

        <mytable ref="getSysDruidLogList" :tableColums='tableColums_getSysDruidLogList' api='getSysDruidLogList'
            xupdateapi='updateUser' :height="H - 165">
        </mytable>
        <el-dialog title="详情" :visible.sync="detailShow" width="95%" :before-close="DeailClose" top="5vh">
            <el-row style="margin-bottom:10px;">
                <el-button v-if="DetailList.sdlType == 2" plain size='small' style='margin-left:10px;'
                    :type="tabs == 1 ? 'primary' : ''" @click="tabs = 1">首页</el-button>
                <el-button v-if="DetailList.sdlType == 2" plain size='small' style='margin-left:10px;'
                    :type="tabs == 2 ? 'primary' : ''" @click="tabs = 2">数据源</el-button>
                <el-button v-if="DetailList.sdlType == 1" plain size='small' style='margin-left:10px;'
                    :type="tabs == 3 ? 'primary' : ''" @click="tabs = 3">SQL监控</el-button>
                <el-button v-if="DetailList.sdlType == 1" plain size='small' style='margin-left:10px;'
                    :type="tabs == 4 ? 'primary' : ''" @click="tabs = 4">SQL防火墙</el-button>
                <el-button v-if="DetailList.sdlType == 1" plain size='small' style='margin-left:10px;'
                    :type="tabs == 5 ? 'primary' : ''" @click="tabs = 5">Web应用</el-button>
                <el-button v-if="DetailList.sdlType == 1" plain size='small' style='margin-left:10px;'
                    :type="tabs == 6 ? 'primary' : ''" @click="tabs = 6">Url监控</el-button>
            </el-row>
            <div style="width: 100%;padding: 15px;height: 550px;overflow-y: auto;">
                <el-descriptions v-if="tabs == 1 && DetailList.basicJson" :column="3" border :labelStyle="{
                color: '#409EFF',
                textAlign: 'center',
                width: '14%',
                fontSize: '12px'
            }" :contentStyle="{ textAlign: 'center', width: '18%', fontSize: '12px' }">
                    <el-descriptions-item label="版本">{{ DetailList.basicJson.Content.Version }}</el-descriptions-item>
                    <el-descriptions-item label="驱动">{{ DetailList.basicJson.Content.Drivers.toString()
                        }}</el-descriptions-item>
                    <el-descriptions-item label="是否允许重置">{{ DetailList.basicJson.Content.ResetEnable
                        }}</el-descriptions-item>
                    <el-descriptions-item label="重置次数">{{ DetailList.basicJson.Content.ResetCount
                        }}</el-descriptions-item>
                    <el-descriptions-item label="Java版本">{{ DetailList.basicJson.Content.JavaVersion
                        }}</el-descriptions-item>
                    <el-descriptions-item label="JVM名称">{{ DetailList.basicJson.Content.JavaVMName
                        }}</el-descriptions-item>
                    <el-descriptions-item label="启动时间">{{ DetailList.basicJson.Content.StartTime
                        }}</el-descriptions-item>
                </el-descriptions>
                <el-descriptions v-if="tabs == 2 && DetailList.datasourceJson" :column="3" border :labelStyle="{
                color: '#409EFF',
                textAlign: 'center',
                width: '14%',
                fontSize: '12px'
            }" :contentStyle="{ textAlign: 'center', width: '18%', fontSize: '12px' }">
                    <el-descriptions-item label="用户名">{{ DetailList.datasourceJson.Content[0].UserName
                        }}</el-descriptions-item>
                    <el-descriptions-item label="连接地址" :span="2">{{ DetailList.datasourceJson.Content[0].URL
                        }}</el-descriptions-item>
                    <el-descriptions-item label="数据库类型">{{ DetailList.datasourceJson.Content[0].DbType
                        }}</el-descriptions-item>
                    <el-descriptions-item label="驱动类名">{{ DetailList.datasourceJson.Content[0].DriverClassName
                        }}</el-descriptions-item>
                    <el-descriptions-item label="filter类名">{{
                DetailList.datasourceJson.Content[0].ExceptionSorterClassName }}</el-descriptions-item>

                    <el-descriptions-item label="获取连接时检测">{{ DetailList.datasourceJson.Content[0].TestOnBorrow
                        }}</el-descriptions-item>
                    <el-descriptions-item label="空闲时检测">{{ DetailList.datasourceJson.Content[0].TestWhileIdle
                        }}</el-descriptions-item>
                    <el-descriptions-item label="连接放回连接池时检测">{{ DetailList.datasourceJson.Content[0].TestOnReturn
                        }}</el-descriptions-item>
                    <el-descriptions-item label="初始化连接大小">{{ DetailList.datasourceJson.Content[0].InitialSize
                        }}</el-descriptions-item>
                    <el-descriptions-item label="最小空闲连接数">{{ DetailList.datasourceJson.Content[0].MinIdle
                        }}</el-descriptions-item>
                    <el-descriptions-item label="最大连接数">{{ DetailList.datasourceJson.Content[0].MaxActive
                        }}</el-descriptions-item>
                    <el-descriptions-item label="查询超时时间">{{ DetailList.datasourceJson.Content[0].QueryTimeout
                        }}</el-descriptions-item>
                    <el-descriptions-item label="事务查询超时时间">{{
                DetailList.datasourceJson.Content[0].TransactionQueryTimeout }}</el-descriptions-item>
                    <el-descriptions-item label="登录超时时间">{{ DetailList.datasourceJson.Content[0].LoginTimeout
                        }}</el-descriptions-item>
                    <el-descriptions-item label="连接有效性检查类名">{{
                DetailList.datasourceJson.Content[0].ValidConnectionCheckerClassName }}</el-descriptions-item>
                    <el-descriptions-item label=" ExceptionSorter类名">{{
                DetailList.datasourceJson.Content[0].ExceptionSorterClassName }}</el-descriptions-item>
                    <el-descriptions-item label=" 默认autocommit设置">{{
                DetailList.datasourceJson.Content[0].DefaultAutoCommit }}</el-descriptions-item>
                    <el-descriptions-item label=" 默认只读设置">{{ DetailList.datasourceJson.Content[0].DefaultReadOnly
                        }}</el-descriptions-item>
                    <el-descriptions-item label=" 默认事务隔离">{{
                DetailList.datasourceJson.Content[0].DefaultTransactionIsolation }}</el-descriptions-item>
                    <el-descriptions-item label=" MinEvictableIdleTimeMillis">{{
                DetailList.datasourceJson.Content[0].MinEvictableIdleTimeMillis }}</el-descriptions-item>
                    <el-descriptions-item label=" MaxEvictableIdleTimeMillis">{{
                DetailList.datasourceJson.Content[0].MaxEvictableIdleTimeMillis }}</el-descriptions-item>
                    <el-descriptions-item label=" KeepAlive">{{ DetailList.datasourceJson.Content[0].KeepAlive
                        }}</el-descriptions-item>
                    <el-descriptions-item label=" FailFast">{{ DetailList.datasourceJson.Content[0].FailFast
                        }}</el-descriptions-item>
                    <el-descriptions-item label=" PoolPreparedStatements">{{
                DetailList.datasourceJson.Content[0].PoolPreparedStatements }}</el-descriptions-item>
                    <el-descriptions-item label="MaxPoolPreparedStatementPerConnectionSize">{{
                DetailList.datasourceJson.Content[0].MaxPoolPreparedStatementPerConnectionSize
            }}</el-descriptions-item>
                    <el-descriptions-item label="MaxWait">{{ DetailList.datasourceJson.Content[0].MaxWait
                        }}</el-descriptions-item>
                    <el-descriptions-item label="MaxWaitThreadCount">{{
                DetailList.datasourceJson.Content[0].MaxWaitThreadCount }}</el-descriptions-item>
                    <el-descriptions-item label="LogDifferentThread">{{
                DetailList.datasourceJson.Content[0].LogDifferentThread }}</el-descriptions-item>
                    <el-descriptions-item label="UseUnfairLock">{{ DetailList.datasourceJson.Content[0].UseUnfairLock
                        }}</el-descriptions-item>
                    <el-descriptions-item label="InitGlobalVariants">{{
                DetailList.datasourceJson.Content[0].InitGlobalVariants }}</el-descriptions-item>
                    <el-descriptions-item label="InitVariants">{{ DetailList.datasourceJson.Content[0].InitVariants
                        }}</el-descriptions-item>
                    <el-descriptions-item label="累计总次数">{{ DetailList.datasourceJson.Content[0].NotEmptyWaitCount
                        }}</el-descriptions-item>
                    <el-descriptions-item label="等待总时长">{{ DetailList.datasourceJson.Content[0].NotEmptyWaitMillis
                        }}</el-descriptions-item>
                    <el-descriptions-item label="等待线程数量">{{ DetailList.datasourceJson.Content[0].WaitThreadCount
                        }}</el-descriptions-item>
                    <el-descriptions-item label="事务启动数">{{ DetailList.datasourceJson.Content[0].StartTransactionCount
                        }}</el-descriptions-item>
                    <el-descriptions-item label="事务时间分布">{{ DetailList.datasourceJson.Content[0].TransactionHistogram
                        }}</el-descriptions-item>
                    <el-descriptions-item label="池中连接数">{{ DetailList.datasourceJson.Content[0].PoolingCount
                        }}</el-descriptions-item>
                    <el-descriptions-item label="池中连接数峰值">{{ DetailList.datasourceJson.Content[0].PoolingPeak
                        }}</el-descriptions-item>
                    <el-descriptions-item label="池中连接数峰值时间">{{ DetailList.datasourceJson.Content[0].PoolingPeakTime
                        }}</el-descriptions-item>
                    <el-descriptions-item label="活跃连接数">{{ DetailList.datasourceJson.Content[0].ActiveCount
                        }}</el-descriptions-item>
                    <el-descriptions-item label="活跃连接数峰值">{{ DetailList.datasourceJson.Content[0].ActivePeak
                        }}</el-descriptions-item>
                    <el-descriptions-item label="活跃连接数峰值时间">{{ DetailList.datasourceJson.Content[0].ActivePeakTime
                        }}</el-descriptions-item>
                    <el-descriptions-item label="逻辑连接打开次数">{{ DetailList.datasourceJson.Content[0].LogicConnectCount
                        }}</el-descriptions-item>
                    <el-descriptions-item label="逻辑连接关闭次数">{{ DetailList.datasourceJson.Content[0].LogicCloseCount
                        }}</el-descriptions-item>
                    <el-descriptions-item label="逻辑连接错误次数">{{
                DetailList.datasourceJson.Content[0].LogicConnectErrorCount }}</el-descriptions-item>
                    <el-descriptions-item label="校验失败废弃连接数">{{ DetailList.datasourceJson.Content[0].DiscardCount
                        }}</el-descriptions-item>
                    <el-descriptions-item label="逻辑连接回收重用次数">{{
                DetailList.datasourceJson.Content[0].LogicConnectionRecycleCount }}</el-descriptions-item>
                    <el-descriptions-item label="物理连接打开次数">{{ DetailList.datasourceJson.Content[0].PhysicalConnectCount
                        }}</el-descriptions-item>
                    <el-descriptions-item label="物理关闭数量">{{ DetailList.datasourceJson.Content[0].PhysicalCloseCount
                        }}</el-descriptions-item>
                    <el-descriptions-item label="物理连接错误次数">{{
                DetailList.datasourceJson.Content[0].PhysicalConnectErrorCount }}</el-descriptions-item>
                    <el-descriptions-item label="执行数">{{ DetailList.datasourceJson.Content[0].ExecuteCount
                        }}</el-descriptions-item>
                    <el-descriptions-item label="ExecuteQueryCount">{{
                DetailList.datasourceJson.Content[0].ExecuteQueryCount }}</el-descriptions-item>
                    <el-descriptions-item label="ExecuteUpdateCount">{{
                DetailList.datasourceJson.Content[0].ExecuteUpdateCount }}</el-descriptions-item>
                    <el-descriptions-item label="ExecuteBatchCount">{{
                DetailList.datasourceJson.Content[0].ExecuteBatchCount }}</el-descriptions-item>
                    <el-descriptions-item label="错误数">{{ DetailList.datasourceJson.Content[0].ErrorCount
                        }}</el-descriptions-item>
                    <el-descriptions-item label="提交数">{{ DetailList.datasourceJson.Content[0].CommitCount
                        }}</el-descriptions-item>
                    <el-descriptions-item label="回滚数">{{ DetailList.datasourceJson.Content[0].RollbackCount
                        }}</el-descriptions-item>
                    <el-descriptions-item label="真实PreparedStatement打开次数">{{
                DetailList.datasourceJson.Content[0].RealPreparedStatementOpenCount }}</el-descriptions-item>
                    <el-descriptions-item label="真实PreparedStatement关闭次数">{{
                DetailList.datasourceJson.Content[0].RealPreparedStatementClosedCount }}</el-descriptions-item>
                    <el-descriptions-item label="PSCache访问次数">{{ DetailList.datasourceJson.Content[0].PSCacheAccessCount
                        }}</el-descriptions-item>

                    <el-descriptions-item label="PSCache命中次数">{{ DetailList.datasourceJson.Content[0].PSCacheHitCount
                        }}</el-descriptions-item>
                    <el-descriptions-item label="PSCache不命中次数">{{ DetailList.datasourceJson.Content[0].PSCacheMissCount
                        }}</el-descriptions-item>
                    <el-descriptions-item label="连接持有时间分布">{{
                DetailList.datasourceJson.Content[0].ConnectionHoldTimeHistogram }}</el-descriptions-item>
                    <el-descriptions-item label="Clob打开次数">{{ DetailList.datasourceJson.Content[0].ClobOpenCount
                        }}</el-descriptions-item>
                    <el-descriptions-item label="Blob打开次数">{{ DetailList.datasourceJson.Content[0].BlobOpenCount
                        }}</el-descriptions-item>
                    <el-descriptions-item label="KeepAlive检测次数">{{
                DetailList.datasourceJson.Content[0].KeepAliveCheckCount }}</el-descriptions-item>

                </el-descriptions>
                <el-table v-if="tabs == 3 && DetailList.sql" height="500" :data="DetailList.sql.Content || []" border
                    highlight-current-row :header-cell-style="{
                textAlign: 'center',
                background: 'rgba(0,170,255,0.5)',
                color: 'black',
                border: 'none'
            }" style="width: 100%;margin:12px 0 0 0;">
                    <el-table-column type="index" width="50" label="序号" fixed="left">
                    </el-table-column>
                    <el-table-column prop="SQL" label="SQL" width="700"> </el-table-column>
                    <el-table-column prop="ExecuteCount" label="执行数" width="90" sortable> </el-table-column>
                    <el-table-column prop="TotalTime" label="执行时间" width="110"> </el-table-column>
                    <el-table-column prop="MaxTimespan" label="最慢" width="90" sortable> </el-table-column>
                    <el-table-column prop="Txn" label="事务执行"> </el-table-column>
                    <el-table-column prop="ErrorCount" label="错误数" sortable> </el-table-column>
                    <el-table-column prop="UpdateCount" label="更新行数" sortable> </el-table-column>
                    <el-table-column prop="FetchRowCount" label="读取行数" sortable> </el-table-column>
                    <el-table-column prop="RunningCount" label="执行中"> </el-table-column>
                    <el-table-column prop="ConcurrentMax" label="最大并发" sortable> </el-table-column>
                </el-table>
                <el-table v-if="tabs == 4 && DetailList.wall" height="500" :data="DetailList.wall.Content.tables || []"
                    border highlight-current-row :header-cell-style="{
                textAlign: 'center',
                background: 'rgba(0,170,255,0.5)',
                color: 'black',
                border: 'none'
            }" style="width: 100%;margin:12px 0 0 0;">
                    <el-table-column type="index" width="50" label="序号" fixed="left">
                    </el-table-column>
                    <el-table-column prop="name" label="表名" width="300"> </el-table-column>
                    <el-table-column prop="selectCount" label="Select数" width="110" sortable> </el-table-column>
                    <el-table-column prop="insertCount" label="Insert数" width="110" sortable> </el-table-column>
                    <el-table-column prop="updateCount" label="Update数" sortable> </el-table-column>
                    <el-table-column prop="deleteCount" label="Delete数" sortable> </el-table-column>
                    <el-table-column prop="createCount" label="Create数" sortable> </el-table-column>
                    <el-table-column prop="alterCount" label="Alter数" sortable> </el-table-column>
                    <el-table-column prop="fetchRowCount" label="读取行数" sortable> </el-table-column>

                </el-table>
                <el-descriptions v-if="tabs == 5 && DetailList.webapp" :column="3" border :labelStyle="{
                color: '#409EFF',
                textAlign: 'center',
                width: '14%',
                fontSize: '12px'
            }" :contentStyle="{ textAlign: 'center', width: '18%', fontSize: '12px' }">
                    <el-descriptions-item label="ContextPath">{{ DetailList.webapp.Content[0].ContextPath
                        }}</el-descriptions-item>
                    <el-descriptions-item label="执行中">{{ DetailList.webapp.Content[0].RunningCount
                        }}</el-descriptions-item>
                    <el-descriptions-item label="最大并发">{{ DetailList.webapp.Content[0].ConcurrentMax
                        }}</el-descriptions-item>
                    <el-descriptions-item label="请求次数">{{ DetailList.webapp.Content[0].RequestCount
                        }}</el-descriptions-item>
                    <el-descriptions-item label="SessionCount">{{ DetailList.webapp.Content[0].SessionCount
                        }}</el-descriptions-item>
                    <el-descriptions-item label="事务提交数">{{ DetailList.webapp.Content[0].CommitCount
                        }}</el-descriptions-item>
                    <el-descriptions-item label="事务回滚数">{{ DetailList.webapp.Content[0].RollbackCount
                        }}</el-descriptions-item>
                    <el-descriptions-item label="Jdbc执行数">{{ DetailList.webapp.Content[0].JdbcExecuteCount
                        }}</el-descriptions-item>
                    <el-descriptions-item label="Jdbc时间">{{ DetailList.webapp.Content[0].JdbcExecTimeMillis
                        }}</el-descriptions-item>
                    <el-descriptions-item label="读取行数">{{ DetailList.webapp.Content[0].FetchRowCount
                        }}</el-descriptions-item>
                    <el-descriptions-item label="更新行数">{{ DetailList.webapp.Content[0].UpdateCount
                        }}</el-descriptions-item>
                </el-descriptions>
                <el-table v-if="tabs == 6 && DetailList.weburi" height="500" :data="DetailList.weburi.Content || []"
                    border highlight-current-row :header-cell-style="{
                textAlign: 'center',
                background: 'rgba(0,170,255,0.5)',
                color: 'black',
                border: 'none'
            }" style="width: 100%;margin:12px 0 0 0;">
                    <el-table-column type="index" width="50" label="序号" fixed="left">
                    </el-table-column>
                    <el-table-column prop="URI" label="URI" width="350"> </el-table-column>
                    <el-table-column prop="RequestCount" label="请求次数" width="100" sortable> </el-table-column>
                    <el-table-column prop="RequestTimeMillis" label="请求时间" width="110" sortable> </el-table-column>
                    <el-table-column prop="RequestTimeMillisMax" label="请求最慢" width="110" sortable>
                    </el-table-column>
                    <!-- <el-table-column prop="RunningCount" label="执行中"> </el-table-column> -->
                    <el-table-column prop="ConcurrentMax" label="最大并发"> </el-table-column>
                    <el-table-column prop="JdbcExecuteCount" label="Jdbc执行数" sortable> </el-table-column>
                    <el-table-column prop="JdbcExecErrorCount" label="Jdbc出错数" sortable> </el-table-column>
                    <el-table-column prop="JdbcExecTimeMillis" label="Jdbc时间" sortable> </el-table-column>
                    <el-table-column prop="CommitCount" label="事务提交数" sortable> </el-table-column>
                    <el-table-column prop="RollbackCount" label="事务回滚数" sortable> </el-table-column>
                    <el-table-column prop="FetchRowCount" label="读取行数" sortable> </el-table-column>
                    <el-table-column prop="UpdateCount" label="更新行数" sortable> </el-table-column>
                </el-table>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            tabs: 1,
            DetailList: '',
            detailShow: false,
            valueDate: '',
            userId: null,
            theProjectId: "",
            theUserProject: "",
            theLogInstanceAll: [
                { id: 8, name: "equityfee", label: "equityfee" },
                { id: 9, name: "equitybackfee", label: "equitybackfee" },
                { id: 9, name: "pointsequity", label: "pointsequity" },
                { id: 2, name: "appcenter", label: "appcenter" },
                { id: 1, name: "opportunity", label: "opportunity" },
                { id: 10, name: "aicourse", label: "aicourse" },
                { id: 7, name: "assetsuse", label: "assetsuse" },
                { id: 5, name: "interview", label: "interview" },
                { id: 6, name: "ajtools", label: "ajtools" },
                { id: 4, name: "trainingmsg", label: "msg" },
                { id: 9, name: "equityshanxi", label: "equityshanxi" },
            ],
            logInstance: "",
            tableColums_getSysDruidLogList: {
                $selection: false,

                sdlInstance: ['微服务名称', 130,],
                createtime: ['请求时间', 160,],
                // logMethod: '请求方式',
                // logRawPath: '请求地址',
                sdlIp: '微服务ip',
                // logParams: '请求参数',
                sdlType: ['类型', 200, '@v-if: 2:新建 #danger,1:记录 #success'],
                sdlStatus: ['状态', 120, '@v-if: 3:已删除 #danger,  1:未处理 #warn,2:已处理 #success'],
                $operation: [
                    '操作', 250, `@text: 详情#success @click: handelDetail($row)`,
                    this.updateSysDruidLogStatus && `@text: 编辑状态#success
           @v-if: $row.sdlStatus == 1
           @click: _confirm('确定要更新已处理吗?')
                   .trigger('updateSysDruidLogStatus',{sdlId:$row.sdlId})
                   .trigger('getSysDruidLogList')
          `,
                    this.deleteSysDruidLog && `@text: 删除#danger
                    @v-if: $row.sdlStatus !== 3
               @click: _confirm('确定要删除吗?')
                       .trigger('deleteSysDruidLog',{sdlId:$row.sdlId})
                       .trigger('getSysDruidLogList')
              `,
                ],
            },

        };
    },

    watch: {

    },

    methods: {
        getData() {
            this.getSysDruidLogList({
                sdlType: this.getSysDruidLogList_data.sdlType,
                sdlInstance: this.getSysDruidLogList_data.sdlInstance,
                sdlIp: this.getSysDruidLogList_data.sdlIp,
                createtimeStart: this.getSysDruidLogList_data.createtimeStart,
                createtimeEnd: this.getSysDruidLogList_data.createtimeEnd,
                currentPage: 1,
            });
        },
        DeailClose() {
            this.detailShow = false;
            this.DetailList = '';
            this.tabs = 1
        },
        handelDetail(row) {
            this.getSysDruidLogDetails({ sdlId: row.sdlId }).result(res => {
                if (row.sdlType == 1) {
                    this.tabs = 3
                }
                this.DetailList = res.data.data;
                this.detailShow = true;
            })
        },
        timeChange(e) {
            if (e) {
                this.getSysDruidLogList_data.createtimeStart = e[0];
                this.getSysDruidLogList_data.createtimeEnd = e[1];
            } else {
                this.getSysDruidLogList_data.createtimeStart = "";
                this.getSysDruidLogList_data.createtimeEnd = "";
            }
            this.getData();
        },

    },

    created() {
        this.getSysDruidLogList();
    },
    mounted() {

    }
};
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/views/data/druidLog.vue